import React from "react";
import VsIcon from "../../assets/VsBrownIcon.svg";
import CustomText from "../CustomText";
import moment from "moment";
import Colors from "../../config/Colors";

interface MatchProps {
  className?: string;
  team1Name?: string;
  team1Image?: string;
  team2Name?: string;
  team2Image?: string;
  marginTop?: string | number;
  marginBottom?: string | number;
  marginLeft?: string | number;
  marginRight?: string | number;
  onClick?: () => void;
  startTime?: string;
  isPlayed?: boolean;
}

function MatchCard({
  className,
  team1Image,
  team1Name,
  team2Image,
  team2Name,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  onClick,
  startTime,
  isPlayed,
}: MatchProps) {
  const formattedTime = moment(startTime + "Z").format("hh:mm A");
  const formattedDate = moment(startTime + "Z").format("DD MMMM");

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      style={{
        marginBottom,
        marginLeft,
        marginRight,
        marginTop,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        opacity: isPlayed ? 0.5 : 1,
      }}
      onClick={handleClick}
    >
      <div className={`cardMatchCardContainer relative ${className} `}>
        <div
          style={{
            position: "absolute",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            top: -10,
          }}
        >
          {isPlayed && (
            <div
              style={{
                backgroundColor: Colors.primary,
                paddingInline: 20,
                borderRadius: 5,
                height: 24,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CustomText
                size="xxsmall"
                weight="700"
                color={Colors.white}
                marginBottom={1}
              >
                Picks Submitted
              </CustomText>
            </div>
          )}
          <CustomText
            size="xxsmall"
            weight="700"
            marginTop={isPlayed ? 3 : 15}
            marginBottom={5}
            color={Colors.brownPrimary}
            style={{ opacity: isPlayed ? 1 : 0.6 }}
          >
            {formattedDate} at {formattedTime}
          </CustomText>
        </div>
        <div
          className={`cardMatchCard ${isPlayed && "cardMatchCardIsPlayed"}`}
          style={{
            backgroundColor: Colors.backgroundPrimary,
          }}
        >
          <div className="cardMatchTeam">
            <img src={team1Image} alt="" className="cardMatchTeamLogo" />
            <CustomText size="small" weight="600" marginTop={5} color={"#444"}>
              {team1Name}
            </CustomText>
          </div>
          <img
            src={VsIcon}
            alt=""
            className="cardMatchCardVs"
            style={{ marginTop: 20, flex: 2 }}
          />
          <div className="cardMatchTeam">
            <img src={team2Image} alt="" className="cardMatchTeamLogo" />
            <CustomText size="small" weight="600" marginTop={5} color={"#444"}>
              {team2Name}
            </CustomText>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MatchCard;
